import { Typography, Box, useTheme, Stack, IconButton, Dialog, DialogContent, Button, DialogTitle,DialogContentText,DialogActions} from "@mui/material";
import { tokens } from "../../theme";
import NiceDate from "../../components/global/NiceDate";
import { useDispatch, useSelector } from "react-redux";
import { getSignMessages,updateSignMessage} from "../../slices/sign_message";
import { setMessage , clearMessage} from "../../slices/message"
import DeleteIcon from '@mui/icons-material/Delete';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import { Link, useNavigate } from "react-router-dom";
import InfoIcon from '@mui/icons-material/Info';
import React, { useState, useEffect,useMemo } from 'react';
import { GridColumns,
  GridCellParams,
  GridRowsProp,
  DataGrid,
  GridCellModesModel,
  GridCellModes} from "@mui/x-data-grid";
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import SignService from "../../services/sign.service"
import SignMessageEdit from "./SignMessageEdit";
import { now } from "moment/moment";


const SignMessages = (props) => {

  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);


  const signId = props.sign.id;

     
  const callBack = props.commandCallBack

  const dispatch = useDispatch();

  const signMessages = useSelector((state) => state.signMessage);
  const signMessagesData = signMessages.data.list.filter(message => message.active == true)

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [selectedMessage, setSelectedMessage] = React.useState(null);
  const [refreshTracker , setRefreshTracker] = React.useState(0);

  const sendSignMessageCommand = async ( id, messageID) => {

    try {
      const commandId = await SignService.setSignMessage(id,messageID)
      .then((response => {
          callBack(response.commandId) 
        }))

    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      dispatch(setMessage(message));
  }
  ;}


  useEffect(() => {
    
    const search = {
      page,
      pageSize,
      signId: signId,
      active: true
    }

    dispatch(getSignMessages({search}));

  }, [page,pageSize,props.sign,refreshTracker]);

  const [editOpen, setEditOpen] = React.useState(false);
  const [messageToDelete, setMessageToDelete] = React.useState(null);
  
  const handleClose = (doUpdate) => {
    setEditOpen(false);

    //debugger;

    if(doUpdate == true){
      setPage(0);
      setRefreshTracker(refreshTracker + 1);
    }
  };

  const doDelete = () => {
    dispatch(clearMessage());

    const message = {
      id: messageToDelete,
      active: false,
    };

    dispatch(updateSignMessage({message}));
    setOpenConfirmDelete(false);
    
  }
  
  const columns = [
    { 
      field: "id", 
      headerName: "ID" ,
      hide: true,
    },
    { 
      field: "name", 
      headerName: "Message" ,
      flex: 1,
    },
    { 
      field: "message", 
      headerName: "Message Text" ,
      flex: 2,
    },
    { 
      field: "displayedTimes", 
      headerName: "Used" ,
      flex: 1,
    },
    
    {
      field: "lastDisplayed",
      headerName: "Last Sent to Sign", 
      flex: 1,
      renderCell: ({row: {lastDisplayed}}) => {

        return (
          <NiceDate>{lastDisplayed}</NiceDate>
        )
      }
    },
    {
      headerName: "Actions",
      field:"",
      width: 150,
      minWidth: 150,
      type:"actions",
      disableClickEventBubbling: true,

      
      renderCell: (params) => {

          const handleSend = (e) => {
            e.stopPropagation();
            dispatch(clearMessage());
            const currentRow = params.row;
            const messageID = currentRow.id;

            sendSignMessageCommand(signId,messageID)

          };

          const handleDelete = (e) => {
            e.stopPropagation();
            const currentRow = params.row;
            const messageID = currentRow.id;

            setMessageToDelete(messageID);

            setOpenConfirmDelete(true);
          };

          const handleEdit= (e) => {
            e.stopPropagation();
            dispatch(clearMessage());
            const currentRow = params.row;
            const messageID = currentRow.id;

            setSelectedMessage(currentRow);
            setEditOpen(true);

          };

          

          return (
            
            <Stack key={"STACK-" + params.row.id}  direction="row" spacing={2}>

              
              <IconButton key={"SEND-" + params.row.id}  aria-label="send" onClick={handleSend}>
                <ForwardToInboxOutlinedIcon fontSize="small"/>
              </IconButton>

              <IconButton key={"EDIT-" + params.row.id} aria-label="delete" onClick={handleEdit}>
                <EditIcon fontSize="small"/>
              </IconButton>

              <IconButton key={"DELETE-" + params.row.id} aria-label="delete" onClick={handleDelete}>
                <DeleteIcon fontSize="small"/>
              </IconButton>

            </Stack>
          );
      },
    },

  ];

  const [openConfirmDelete, setOpenConfirmDelete] = React.useState(false);

  const handleCloseConfirmDelete = () => {
    setOpenConfirmDelete(false);
  };



  return (
    <>

    <Dialog
      open={openConfirmDelete}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Really delete message?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          This action will permentaly remove the message from your sign.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseConfirmDelete} autoFocus>No</Button>
        <Button onClick={doDelete} >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
      
    <Dialog open={editOpen} >
        
        <DialogContent>
          <SignMessageEdit message = {selectedMessage} closer = {handleClose} signId = {signId} sender = {sendSignMessageCommand}/>
        </DialogContent>

      </Dialog>

    <Box>

      <Box display = "flex" justifyContent="flex-end" >
        <Button 
          color="secondary" 
          variant="contained" 
          onClick={() => {
            setSelectedMessage(null);
            setEditOpen(true);
          }}
        >
          Create new message
        </Button>
      </Box>

      <Box
        mt = "20px"
        height="40vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >

        <DataGrid  experimentalFeatures={{newEditingApi: true }}
            rows={signMessagesData} 
            columns={columns} 
            pageSize={pageSize}
            page={signMessages.data.page}
            rowsPerPageOptions={[5, 10,25,50,100]}
            paginationMode="server"
            rowCount={signMessages.data.total}
            onPageChange={(newPage) => setPage(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          />    

      </Box>

      
    </Box>
    </>
    
  );
};

export default SignMessages;
